import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { ReportConfigPage } from "./report-config.page";

const routes: Routes = [
  {
    path: "",
    component: ReportConfigPage,
  },
  {
    path: "add-report-config",
    loadChildren: () =>
      import("./edit-report-config/edit-report-config.module").then(
        (m) => m.EditReportConfigPageModule
      ),
    // loadChildren: () => import( './add-report-config/add-report-config.module').then( m => m.AddReportConfigPageModule),
    data: {
      breadcrumb: "REPORT_CONFIG.NEW_REPORT_CONFIG",
    },
  },
  {
    path: "edit-report-config/:ReportConfigId",
    loadChildren: () =>
      import("./edit-report-config/edit-report-config.module").then(
        (m) => m.EditReportConfigPageModule
      ),
    data: {
      breadcrumb: "REPORT_CONFIG.EDIT_REPORT_CONFIG",
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportConfigPageRoutingModule {}
